module.exports = __webpack_public_path__ + "static/media/logo.abe02213.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.svg
// module id = 508
// module chunks = 0